"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		'use strict';

		var functions = require('./functions');
		var maps = require('./maps');
		var search = require('./search');

		var pages = {
			documents: require('./pages/documents'),
			email_alerts: require('./pages/email-alerts'),
			disclaimer: require('./pages/disclaimer'),
			search_results: require('./pages/search-results'),
			people: require('./pages/people')
		};

		var app = {
			init: function init() {
				var pageSelector = 'data-template-name';

				// call your functions here
				functions.loadImages();
				functions.headerFunctions();
				functions.tabs();
				functions.accordion();
				functions.cleanRteTables();
				functions.removeUnnecessaryTagsFromRTE();
				functions.cookies();
				functions.stickyFooter();
				functions.initSelectric();
				functions.peoplePopup();
				functions.backToTop();
				functions.sidebarNavigation();
				functions.slideToThankYouMessage();
				functions.slideToProjectAccordion();
				if ($('.module-map-container').length) {
					maps.initMap();
				}

				if (document.querySelector('[' + pageSelector + ']') !== null) {
					var pageName = document.querySelector('[' + pageSelector + ']').getAttribute(pageSelector);
					if (pageName && pages[pageName] && pages[pageName].init) {
						pages[pageName].init();
					}
				}

				search.initSearch('#header-search', '.header-search-desktop .btn-submit');
				search.initSearch('#sidebar-search', '.sidebar-search .btn-submit');
				search.initSearch('#header-search-mobile', '.header-search-mobile .btn-submit');

				if (('ontouchstart' in window || navigator.msMaxTouchPoints > 0) && $(window).width() <= 1024) {
					$('html').addClass('touch');
				} else {
					$('html').addClass('no-touch');
				}
			},
			winLoad: function winLoad() {
				// call functions that are needed for window load
				$('html').addClass('loaded');
			},
			winResize: function winResize() {
				// call functions that are needed on window resize
				if (!$('.nav').is(':visible')) {
					$('.nav').removeAttr('style');
				}
				functions.stickyFooter();
				functions.loadImages();
			}
		};

		$(function () {
			app.init();
		});

		$(window).on('load', function () {
			app.winLoad();
		});

		$(window).on('resize', function () {
			app.winResize();
		});
	}, { "./functions": 2, "./maps": 3, "./pages/disclaimer": 4, "./pages/documents": 5, "./pages/email-alerts": 6, "./pages/people": 7, "./pages/search-results": 8, "./search": 9 }], 2: [function (require, module, exports) {
		'use strict';

		module.exports = {

			loadImages: function loadImages() {
				$('.img-responsive').each(function () {
					var $img = $(this),
					    srcDesktop = $img.data('src-desktop'),
					    srcMobile = $img.data('src-mobile');

					if ($img.hasClass('bg-responsive')) {
						if ($(window).width() < 768) {
							$img.css('background-image', 'url(' + srcMobile + ')');
						} else {
							$img.css('background-image', 'url(' + srcDesktop + ')');
						}
					} else {
						if ($(window).width() < 768) {
							$img.attr('src', srcMobile);
						} else {
							$img.attr('src', srcDesktop);
						}
					}
				});
			},

			headerFunctions: function headerFunctions() {

				$('.nav li').find('.nav-submenu').parent().addClass('has-children');

				$('.js-toggle-header-search').on('click', function () {
					$(this).toggleClass('toggled');
					if ($(this).hasClass('toggled')) {
						$('.header-search-desktop').stop().slideDown(200, function () {
							$(this).find('input[type="text"]').focus();
							$(this).removeAttr('aria-hidden');
						});
					} else {
						$('.header-search-desktop').stop().slideUp(200, function () {
							$(this).attr('aria-hidden', 'true');
						});
					}
				});

				$('.js-menu-toggle').on('click', function () {
					$(this).toggleClass('toggled');
					if ($(this).hasClass('toggled')) {
						$('.nav').stop().slideDown(400).addClass('opened');
					} else {
						$('.nav-submenu').slideUp(300);
						$('.nav').find('li.opened').removeClass('opened');
						$('.nav').stop().slideUp(300).removeClass('opened');
					}
				});

				if ($(window).width() < 1025 && $(window).width() > 992) {
					var $item = $('.nav-main > li');
					var $submenu = $('.nav-submenu');
					$item.on('click', function (e) {
						e.preventDefault();
						if ($(this).find($submenu).length == 0 || $(this).find($submenu).hasClass('custom-show')) {
							window.location = $(this).find('> a').attr('href');
						}
						$('.custom-show').removeClass('custom-show');
						$(this).find($submenu).addClass('custom-show');
						$(this).find('> a').addClass('custom-show');
					});
				}

				if ($(window).width() < 992) {
					$('.nav-main .has-children .toggle-submenu').on('click', function (e) {
						if ($(this).parent().hasClass('opened')) {
							$(this).parent().removeClass('opened');
							$(this).siblings('.nav-submenu').stop().slideUp(300);
						} else {
							$(this).closest('ul').find('.opened').removeClass('opened');
							$(this).closest('ul').find('.nav-submenu').stop().slideUp(300);
							$(this).parent().addClass('opened');
							$(this).siblings('.nav-submenu').stop().slideDown(300);
						}
					});
				}
			},

			tabs: function tabs() {
				$('.tabs').each(function () {
					var $btn = $(this).find('.tab-link');
					var $tab = $(this).find('.tab');
					var $tabToggle = $(this).find('.tab-toggle');
					var activeClass = 'tab-active';
					$btn.on('click', function () {
						var index = $(this).parent().index();
						$btn.removeClass(activeClass);
						$tab.removeClass(activeClass);
						$(this).addClass(activeClass);
						$tab.eq(index).addClass(activeClass);
					});
					$btn.first().addClass(activeClass);
					$tab.first().addClass(activeClass);

					$tabToggle.on('click', function () {
						$(this).closest('.tabs').toggleClass('tabs-toggled');
					});
				});
			},

			accordion: function accordion() {
				var pageLoad = true;
				$('.accordion').each(function () {
					$(this).find('.accordion-button').on('click', function () {
						var $btn = $(this);
						if ($btn.hasClass('opened')) {
							$btn.removeClass('opened');
							$btn.siblings('.accordion-content').stop().slideUp('fast', function () {
								$(this).attr('aria-hidden', 'true');
								if (!pageLoad) {
									$('html, body').animate({ scrollTop: $btn.offset().top - 20 }, 400);
								}
							});
						} else {
							$btn.parent().siblings().find('.accordion-button.opened').removeClass('opened');
							$btn.parent().siblings().find('.accordion-content').stop().slideUp('fast', function () {
								$(this).attr('aria-hidden', 'true');
							});
							$btn.addClass('opened');
							$btn.siblings('.accordion-content').stop().slideDown('fast', function () {
								$(this).removeAttr('aria-hidden');
								if (!pageLoad) {
									$('html, body').animate({ scrollTop: $btn.offset().top - 20 }, 400);
								}
							});
						}
					});
					if (!$(this).closest('.project-filter-items').length) {
						if (pageLoad) {
							$(this).find('.accordion-row').first().find('.accordion-button').click();
							setTimeout(function () {
								pageLoad = false;
							}, 1000);
						}
					}
				});
			},

			cleanRteTables: function cleanRteTables() {
				var table = $('.rte-content table');
				var rteTable = table.wrap('<div class="table"/>');

				rteTable.removeAttr('style');
				rteTable.removeAttr('border');

				table.find('td, th').removeAttr('style');
			},

			removeUnnecessaryTagsFromRTE: function removeUnnecessaryTagsFromRTE() {
				$('ul.bullets').each(function () {
					var tempText = $(this).find('ul').children();
					$(this).find('ul').remove();
					$(this).append(tempText);
				});
			},

			cookies: function cookies() {
				var self = this;
				var $cookies = $('.cookies');
				if ($cookies.length) {
					$('.footer').css('margin-bottom', $cookies.outerHeight());
					$('.js-close-cookies').on('click', function () {
						$cookies.stop().slideUp(300, function () {
							$cookies.remove();
							self.createCookie('cookieAccepted', 'yes', 365);
							self.stickyFooter();
						});
						$('.footer').removeAttr('style');
					});
					$(window).resize(function () {
						$('.footer').css('margin-bottom', $('.cookies').outerHeight());
					});
				}
			},

			stickyFooter: function stickyFooter() {
				if ($(window).width() > 767) {
					var cookieHeight = 0;
					if ($('.cookies').length) {
						cookieHeight = $('.cookies').outerHeight();
					}
					$('body').css('padding-bottom', $('.footer').outerHeight() + cookieHeight);
				}
			},

			initSelectric: function initSelectric() {
				var $select = $('select');
				if ($select !== undefined && $select.length) {
					$select.selectric({
						disableOnMobile: false,
						nativeOnMobile: false,
						arrowButtonMarkup: '<span class="arrow"></span>'
					});
				}
			},

			peoplePopup: function peoplePopup() {
				if ($('.team-member').length) {
					$('.team-member').find('a').on('click', function (e) {
						var $member = $(this).closest('.team-member');
						var memberDetails = $member.find('.team-member-details').html();
						var $popup = $('.people-popup-overlay');
						$popup.find('.popup-content').html(memberDetails);
						$popup.stop().fadeIn(500).addClass('popup-opened').removeAttr('aria-hidden');
						$('body').addClass('open-popup');

						if ($(window).width() < 768) {
							var popupContentHeight = $popup.find('.popup-content').height();
							var popupImageHeight = $popup.find('.team-member-image').outerHeight(true);
							var popupInfoHeight = $popup.find('.team-member-info').height();

							if (popupImageHeight + popupInfoHeight > popupContentHeight) {
								$popup.find('.scroll-arrow').fadeIn();
							}
							$popup.find('.popup-content').on('scroll', function () {
								var scr = $(this).scrollTop();
								if (scr + popupContentHeight >= popupImageHeight + popupInfoHeight) {
									$popup.find('.scroll-arrow').fadeOut();
								} else {
									$popup.find('.scroll-arrow').fadeIn();
								}
							});
						}

						e.preventDefault();
					});

					// Close popup on click on X, overlay and Escape key
					$(document).on('click', '.people-popup .js-close-popup', function () {
						$('.people-popup-overlay').stop().fadeOut(500, function () {
							$('.people-popup-overlay').find('.popup-content').html('');
						}).removeClass('popup-opened').attr('aria-hidden', 'true');
						$('body').removeClass('open-popup');
					});

					$(document).on('click', '.people-popup-overlay', function (e) {
						if (e.target !== this) return;
						$('.people-popup-overlay').stop().fadeOut(500, function () {
							$('.people-popup-overlay').find('.popup-content').html('');
						}).removeClass('popup-opened').attr('aria-hidden', 'true');
						$('body').removeClass('open-popup');
					});

					$(document).off('keydown').on('keydown', function (e) {
						if (e.which === 27) {
							$('.people-popup-overlay').stop().fadeOut(500, function () {
								$('.people-popup-overlay').find('.popup-content').html('');
							}).removeClass('popup-opened').attr('aria-hidden', 'true');
							$('body').removeClass('open-popup');
						}
					});
				}
			},

			backToTop: function backToTop() {
				$('.btn-to-top').on('click', function () {
					$('html, body').animate({ scrollTop: 0 }, 600);
				});
			},

			createCookie: function createCookie(name, value, days) {
				var expires = '';
				if (days) {
					var date = new Date();
					date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
					expires = "; expires=" + date.toUTCString();
				}
				document.cookie = name + "=" + value + expires + "; path=/";
			},

			// equal heights
			equalHeights: function equalHeights(arrayItems, count) {
				if (arrayItems !== undefined && arrayItems.length > 0) {
					arrayItems.height('');

					var maxH = 0;

					if (count) {
						var arrays = [];
						while (arrayItems.length > 0) {
							arrays.push(arrayItems.splice(0, count));
						}

						for (var i = 0; i < arrays.length; i += 1) {
							var data = arrays[i];
							maxH = 0;
							for (var j = 0; j < data.length; j += 1) {
								var currentH = $(data[j]).outerHeight(true);
								if (currentH > maxH) {
									maxH = currentH;
								}
							}

							for (var k = 0; k < data.length; k += 1) {
								$(data[k]).css('height', maxH);
							}
						}
					} else {
						arrayItems.each(function () {
							var currentH2 = $(this).outerHeight(true);
							if (currentH2 > maxH) {
								maxH = currentH2;
							}
						});

						arrayItems.css('height', maxH);
					}
				}
			},

			sidebarNavigation: function sidebarNavigation() {
				$('.sidebar-links').find('.active').parents('li').removeClass('active');
				$('.sidebar-links').find('.active').parents('li').addClass('sublevel-active');
			},

			slideToThankYouMessage: function slideToThankYouMessage() {
				if ($('.contourMessageOnSubmit').length) {
					$('html, body').animate({ scrollTop: $('.contourMessageOnSubmit').offset().top }, 600);
				}
			},

			slideToProjectAccordion: function slideToProjectAccordion() {
				$(document).on('click', '.popup-link', function () {
					var $pinId = $(this).data('id');
					var $accordionId = $('.accordion-row[id=' + $pinId + ']');

					$('html, body').animate({ scrollTop: $accordionId.offset().top }, 600);
					$accordionId.find('.accordion-button').click();
				});
			}
		};
	}, {}], 3: [function (require, module, exports) {
		'use strict';

		module.exports = {

			map: '',
			// array of categories taken from checkboxes name attribute
			categories: [],
			// array of projects with color, category, latitude and longitude
			projects: [],
			// array of projects that should be shown depending on checkbox selection
			showProjects: [],
			// array of markers to be displayed on the map, also depending on checkbox selection
			markers: [],

			infoWindow: '',

			bindCheckboxEvents: function bindCheckboxEvents() {
				var that = this;
				// clicking on checkboxes will check which categories are selected and it will render the map with new markers
				$('.project-filters input[type="checkbox"]').on('change', function (e) {
					that.getAllCategories();
					that.renderProjects();
					that.renderProjectItems();
				});
			},

			getAllCategories: function getAllCategories() {
				var that = this;
				// pulling the checked categories on page load and checkboxes selection
				$('.project-filters input[type="checkbox"]').each(function () {
					var catName = $(this).attr('name');
					// on checkbox change, if this category exists in the "categories" array, it is being removed from the array
					if (that.categories.indexOf(catName) !== -1) {
						that.categories.splice(that.categories.indexOf(catName), 1);
					}
					// on checkbox change, if the checkbox is checked, this category is added to the "categories" array
					if ($(this).is(':checked')) {
						that.categories.push(catName);
					}
				});
			},

			getProjectsData: function getProjectsData() {
				var that = this;
				// collecting all the data from printed projects
				$('.project-filter-items').find('.accordion-row').each(function () {
					var color = $(this).data('project-color'),
					    category = $(this).data('project-category'),
					    latitude = $(this).data('project-latitude'),
					    longitude = $(this).data('project-longitude'),
					    popupText = $(this).find('.project-popup').html();

					// and adding the data into "projects" array
					that.projects.push({
						color: color,
						category: category,
						latitude: latitude,
						longitude: longitude,
						popupText: popupText
					});
				});
			},

			renderMap: function renderMap() {
				var latitude = 55.864237,
				    longitude = -4.251806,
				    zoomLvl = 8;

				if ($(window).width() < 768) {
					zoomLvl = 7;
				}

				// rendering the google map with already set position and zoom level
				var mapOptions = {
					center: new google.maps.LatLng(latitude, longitude),
					zoom: zoomLvl,
					draggable: true,
					disableDefaultUI: true,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					mapTypeControlOptions: {
						style: google.maps.ZoomControlStyle.SMALL,
						position: google.maps.ControlPosition.TOP_RIGHT
					},
					styles: this.mapStyles
				};

				this.map = new google.maps.Map($('.module-map-container')[0], mapOptions);
			},

			renderProjects: function renderProjects() {
				var that = this;
				// clearing the projects that should be shown, and then filling them up if the requirements are met
				that.showProjects = [];
				var extension = 'svg';

				var isIE = /*@cc_on!@*/false || !!document.documentMode;
				isIE ? extension = 'png' : extension = 'svg';

				// first we have to destroy every marker on the map, otherwise they would always be visible
				for (var j = 0; j < that.markers.length; j++) {
					that.markers[j].setVisible(false);
				}

				// go through every project and create a marker for it with required color, latitude and longitude

				var _loop = function _loop(i) {
					var project = that.projects[i];
					var marker = '';
					var icon = '';

					if ($(window).width() < 768) {
						icon = new google.maps.MarkerImage('/images/pins/map-pin-' + project.color + '-mobile.' + extension, new google.maps.Size(23, 34), new google.maps.Point(0, 0), new google.maps.Point(11, 34));
					} else {
						icon = new google.maps.MarkerImage('/images/pins/map-pin-' + project.color + '.' + extension, new google.maps.Size(37, 56), new google.maps.Point(0, 0), new google.maps.Point(18, 56));
					}

					marker = new google.maps.Marker({
						position: new google.maps.LatLng(project.latitude, project.longitude),
						draggable: false,
						animation: google.maps.Animation.DROP,
						icon: icon,
						map: that.map
					});

					that.infoWindow = new google.maps.InfoWindow({
						maxWidth: 210
					});
					google.maps.event.addListener(marker, 'click', function () {
						var content = project.popupText;
						that.infoWindow.setContent(content);
						that.infoWindow.open(that.map, this);
					});

					// if categories to be visible contain this particular project, we push the project into the array, and it's relative marker to the markers array
					if (that.categories.indexOf(project.category) !== -1) {
						that.showProjects.push(project);
						that.markers.push(marker);
						marker.setVisible(true);
					} else {
						// hiding the markers if they don't belong to the categories array
						marker.setVisible(false);
					}
				};

				for (var i = 0; i < that.projects.length; i++) {
					_loop(i);
				}
			},

			renderProjectItems: function renderProjectItems() {
				var that = this;
				// check every project item if it should be visible
				$('.project-filter-items').find('.accordion-row').each(function () {
					var $this = $(this);
					var catName = $this.data('project-category');
					if (that.categories.indexOf(catName) !== -1) {
						$this.slideDown(300);
					} else {
						$this.find('.accordion-button').removeClass('opened');
						$this.find('.accordion-content').slideUp(200);
						$this.slideUp(200);
					}
				});
			},

			initMap: function initMap() {
				this.getAllCategories();
				this.getProjectsData();
				this.bindCheckboxEvents();
				this.renderMap();
				this.renderProjects();
				this.renderProjectItems();
			},

			mapStyles: [{
				"featureType": "administrative",
				"elementType": "labels",
				"stylers": [{
					"visibility": "simplified"
				}]
			}, {
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [{
					"saturation": "0"
				}, {
					"lightness": "100"
				}, {
					"gamma": "2.31"
				}, {
					"visibility": "on"
				}]
			}, {
				"featureType": "poi.park",
				"elementType": "geometry",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "poi.park",
				"elementType": "labels",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [{
					"saturation": "-100"
				}, {
					"color": "#f5f5f5"
				}]
			}, {
				"featureType": "road",
				"elementType": "labels.text",
				"stylers": [{
					"visibility": "simplified"
				}, {
					"color": "#666666"
				}]
			}, {
				"featureType": "road",
				"elementType": "labels.icon",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "road.arterial",
				"elementType": "geometry.stroke",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "water",
				"elementType": "geometry.fill",
				"stylers": [{
					"lightness": "50"
				}, {
					"gamma": ".75"
				}, {
					"saturation": "100"
				}]
			}]
		};
	}, {}], 4: [function (require, module, exports) {
		'use strict';

		var disclaimer = {
			init: function init() {
				var self = this;
				$('.first-page-btn').on('click', function (e) {
					e.preventDefault();
					var $selectedCountry = $('.selectric-items li.selected');
					var $currentCultureID = $('main').data('current-culture-id');
					var $selectedCountryCode = $('#enquiry').find('option[data-country="' + $selectedCountry.text() + '"]').val();

					if ($selectedCountry.data('index') != 0) {
						$.post('/umbraco/surface/DisclaimerSurface/AllowedAccess', { countryCode: $selectedCountryCode, currentCultureId: $currentCultureID }, function (response) {
							if (response.url === '') {
								self.renderSecondPage();
							} else {
								window.location.href = response.url;
							}
						});
					}
				});
			},

			renderSecondPage: function renderSecondPage() {
				var self = this;
				var $container = $('.rte-content');
				var $currentCultureID = $('main').data('current-culture-id');

				$.post('/umbraco/surface/DisclaimerSurface/SecondPage', { currentCultureId: $currentCultureID }, function (response) {
					$container.children().remove();
					$container.append(response);

					$('.accept-btn').on('click', function () {
						self.createCookie('disclaimerAccepted', 'yes', 365);
						window.location.href = $(this).data('redirect-url');
					});

					$('.decline-btn').on('click', function () {
						window.location.href = $(this).data('redirect-url');
					});
				});
			},

			createCookie: function createCookie(name, value, days) {
				var expires = '';
				if (days) {
					var date = new Date();
					date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
					expires = "; expires=" + date.toUTCString();
				}
				document.cookie = name + "=" + value + expires + "; path=/";
			}
		};

		module.exports = disclaimer;
	}, {}], 5: [function (require, module, exports) {
		'use strict';

		var documents = {
			init: function init() {
				window.location.hash = 'currentPage=1';
				getItems();

				function getItems() {
					var $container = $('.download-list');
					var $year = _typeof($('.tab-active').data('year')) == (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) ? 0 : $('.tab-active').data('year');
					var $archive = _typeof($('.tab-active').attr('archive')) != (typeof undefined === "undefined" ? "undefined" : _typeof(undefined));
					var $currentPage = window.location.hash.split("=")[1];

					$.get('/umbraco/surface/listing/DocumentsListing', { currentPage: $currentPage, year: $year, isArchive: $archive, pagination: true }, function (response) {
						$container.children().remove();
						$container.append(response);

						$('.pagination-item').on('click', function () {
							window.location.hash = 'currentPage=' + $(this).text();
							getItems();
							$('html, body').animate({ scrollTop: $('.tabs').offset().top }, 600);
						});

						$('.arrow-prev').on('click', function () {
							window.location.hash = 'currentPage=' + $(this).data('page');
							getItems();
							$('html, body').animate({ scrollTop: $('.tabs').offset().top }, 600);
						});

						$('.arrow-next').on('click', function () {
							window.location.hash = 'currentPage=' + $(this).data('page');
							getItems();
							$('html, body').animate({ scrollTop: $('.tabs').offset().top }, 600);
						});
					});
				}

				$('.tab-link').on('click', function () {
					$('.download-tab').addClass('tab-active');
					window.location.hash = 'currentPage=1';
					getItems();
				});
			}
		};

		module.exports = documents;
	}, {}], 6: [function (require, module, exports) {
		'use strict';

		var email_alerts = {
			init: function init() {

				if ($('.error').length) {
					setTimeout(function () {
						$('html, body').animate({ scrollTop: $('.error').first().closest('.row').offset().top }, 600);
					}, 300);
				}

				if ($('.success-message').length) {
					$('html, body').animate({ scrollTop: $('.success-message').offset().top }, 600);
				}
				if ($('.error-message').length) {
					$('html, body').animate({ scrollTop: $('.error-message').offset().top }, 600);
				}

				if ($('#ChoosenAlerts').val() != '') {
					var choosenAlerts = $('#ChoosenAlerts').val().split(',');
					for (var i = 0; i < choosenAlerts.length; i++) {
						var checkBoxName = choosenAlerts[i].split(' ')[0];
						$('label[for="' + checkBoxName + '"]').prev().attr('checked', true);
					}
				}

				$("#js-email-alerts-submit").on('click', function (e) {
					//e.preventDefault();
					var errorCounter = 0;
					$('.required-field').each(function () {
						if ($(this).val() == '') {
							errorCounter = errorCounter + 1;
						}
					});
					if (errorCounter === 0) {
						e.preventDefault();
						if (grecaptcha.getResponse() !== "") {
							grecaptcha.reset();
						}
						grecaptcha.execute();
					}
				});

				$('.selectric-items li').on('click', function () {
					var $this = $(this);
					var selectedValue = $this.data('index') === 0 ? '' : $this.text();

					$('#Category').val(selectedValue);
				});

				$("input:checkbox").on('change', function () {
					var value = "";
					var $selectedItems = $("input:checkbox:checked").next();
					for (var _i = 0; _i < $selectedItems.length; _i++) {
						var $item = $selectedItems[_i];
						var isLast = _i === $selectedItems.length - 1;
						value += $item.innerText + (isLast ? "" : ",");
					}

					$("#ChoosenAlerts").val(value);
				});
			}
		};

		module.exports = email_alerts;
	}, {}], 7: [function (require, module, exports) {
		'use strict';

		var people = {
			init: function init() {
				var personId = document.location.hash;
				if (personId.length) {
					$('.expandable-item-visible[data-popup="#item' + personId.replace('#', '') + '"]').find('a').click();
				}
			}
		};

		module.exports = people;
	}, {}], 8: [function (require, module, exports) {
		'use strict';

		var search_results = {
			init: function init() {

				var $container = $('.js-search-results');
				getSearchResultsForPage(1);
				addHrefValueOnSearchTerm();

				function getSearchResultsForPage(currentPage) {
					var data = {
						page: currentPage
					};
					$.ajax({
						type: 'GET',
						url: '/umbraco/surface/listing/SearchResultsListing',
						data: data,
						cache: false,
						success: function success(response) {
							$container.children().remove();
							$container.append(response);
							initPagination();
						}
					});
				}

				function initPagination() {
					$('.pagination-item').on('click', function () {
						getSearchResultsForPage($(this).text());
						addHrefValueOnSearchTerm();
						$('html, body').animate({ scrollTop: $('.search-results').offset().top }, 600);
					});

					$('.arrow-prev').on('click', function () {
						getSearchResultsForPage($(this).data('page'));
						addHrefValueOnSearchTerm();
						$('html, body').animate({ scrollTop: $('.search-results').offset().top }, 600);
					});

					$('.arrow-next').on('click', function () {
						getSearchResultsForPage($(this).data('page'));
						addHrefValueOnSearchTerm();
						$('html, body').animate({ scrollTop: $('.search-results').offset().top }, 600);
					});
				}

				function addHrefValueOnSearchTerm() {
					$('.search-result').each(function () {
						var $url = $(this).find('h2 a').attr('href');
						$(this).find('.search-term-url').attr('href', $url);
					});
				}
			}
		};

		module.exports = search_results;
	}, {}], 9: [function (require, module, exports) {
		'use strict';

		module.exports = {

			initSearch: function initSearch(tboxSelector, linkSelector) {
				var self = this;
				var $tboxSearch = $(tboxSelector),
				    $link = $(linkSelector);

				if ($tboxSearch.length > 0 && $link.length > 0) {
					$link.click(function (e) {
						e.preventDefault();
						var searchTerm = self.strip($tboxSearch.val()).trim(),
						    searchUrl = $('body').data('search-page-url');

						if (searchTerm !== '' && searchTerm !== $tboxSearch.attr('placeholder') && searchUrl != null) {
							window.location.href = searchUrl + (searchUrl.indexOf('?') > -1 ? "&q=" : "?q=") + escape(searchTerm);
						}

						return false;
					});

					$tboxSearch.keypress(function (event) {
						var $self = $(this),
						    searchTerm = $self.val().trim();

						if (event.keyCode === 13 && searchTerm !== '' && searchTerm !== $self.attr('placeholder')) {
							event.stopPropagation();
							$link.click();

							return false;
						} else if (event.keyCode === 13) {
							return false;
						}

						return true;
					});
				}
			},

			strip: function strip(html) {
				var tmp = document.createElement("DIV");
				tmp.innerHTML = html;
				return tmp.textContent || tmp.innerText || "";
			}
		};
	}, {}] }, {}, [1]);